/**
 * Market currency rendering for hardcoded copy figures.
 *
 * The theme's marketing copy is written in the store currency ("$667 value",
 * "$9.95/mo"). snippets/tbf-money-copy.liquid tags each figure with its base
 * amount, and this script re-renders those tags in the visitor's market
 * currency.
 *
 * It deliberately does NOT touch prices that came from a product: those are
 * already converted server-side by Shopify, in the visitor's market currency,
 * and with Shopify's own market rounding applied. Re-converting them here would
 * double-convert and would lose that rounding.
 *
 * Inputs (emitted by the theme from Liquid, so no currency is hardcoded):
 *   html[data-tbf-shop-currency]  store currency, e.g. "AUD"
 *   html[data-tbf-money-format]   Shopify money format, e.g. "${{amount}}"
 *   window.Shopify.currency       { active, rate } supplied by Shopify
 */
(function () {
  'use strict';

  var root = document.documentElement;
  if (!root) return;

  var shopCurrency = root.getAttribute('data-tbf-shop-currency');
  var moneyFormat = root.getAttribute('data-tbf-money-format') || '${{amount}}';

  var shopifyCurrency = window.Shopify && window.Shopify.currency;
  if (!shopifyCurrency) return;

  var active = shopifyCurrency.active;
  var rate = parseFloat(shopifyCurrency.rate);
  if (!active || !shopifyCurrency.rate || isNaN(rate) || rate <= 0) return;

  // Same currency as the copy was written in: the server output is already
  // correct, so leave the DOM completely alone.
  if (shopCurrency && active === shopCurrency) return;

  function stripTrailingZeros(value) {
    return value.replace(/\.00$/, '').replace(/,00$/, '');
  }

  function formatMoney(amount) {
    var parts = amount.toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var decimals = parts[1];

    var rendered = moneyFormat
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, whole)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole + ',' + decimals)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, whole + "'" + decimals)
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + decimals);

    // Matches money_without_trailing_zeros, which the theme renders server-side,
    // so converted and native prices look identical.
    return stripTrailingZeros(rendered);
  }

  function convert(el) {
    if (el.dataset.tbfMoneyDone === '1') return;

    // Conversion Bear (the store's currency app) rewrites money spans and marks
    // them with its own class. Those figures are already converted, so touching
    // them here would convert them a second time.
    //
    // The app nests its span INSIDE ours:
    //   <span class="tbf-money" data-tbf-money="127">
    //     <span class="money conversion-bear-money">$127</span>
    //   </span>
    // so the marker is on a child, not on this element or its parent. Checking
    // descendants is what actually detects it; checking upwards alone misses it
    // and lets `textContent = ...` below wipe the app's span and convert twice.
    var hasAppMarkup =
      (el.className || '').indexOf('conversion-bear') !== -1 ||
      (el.parentElement && (el.parentElement.className || '').indexOf('conversion-bear') !== -1) ||
      el.querySelector('[class*="conversion-bear"]') !== null;

    if (hasAppMarkup) {
      el.dataset.tbfMoneyDone = '1';
      return;
    }

    var base = parseFloat(el.getAttribute('data-tbf-money'));
    if (isNaN(base)) return;

    var converted = base * rate;

    // Shopify rounds market prices to whole units for plain figures like these
    // (e.g. 157 AUD shows as 115 USD, not 114.29). Mirror that when the source
    // figure was a whole number; keep cents when the source has them.
    if (base % 1 === 0) {
      converted = Math.round(converted);
    }

    el.textContent = formatMoney(converted);
    el.dataset.tbfMoneyDone = '1';
  }

  function run() {
    var nodes = document.querySelectorAll('[data-tbf-money]');
    for (var i = 0; i < nodes.length; i++) {
      convert(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Sections injected later (cart drawer, quick add, dynamic upsells) still get
  // converted.
  document.addEventListener('shopify:section:load', run);
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.hasAttribute && node.hasAttribute('data-tbf-money')) {
          convert(node);
        } else if (node.querySelectorAll) {
          var nested = node.querySelectorAll('[data-tbf-money]');
          for (var k = 0; k < nested.length; k++) convert(nested[k]);
        }
      }
    }
  });
  observer.observe(document.body || document.documentElement, { childList: true, subtree: true });

  window.TBFMoney = { run: run, format: formatMoney, rate: rate, active: active };
})();
